import * as React from 'react';
const SvgGridView = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M4.495 9q-.444 0-.761-.327a1.06 1.06 0 0 1-.317-.756V4.5q0-.442.32-.763.323-.32.765-.32h3.42q.445 0 .76.32Q9 4.057 9 4.5v3.417q0 .428-.321.756A1.03 1.03 0 0 1 7.915 9zm0 7.584q-.444 0-.761-.321a1.05 1.05 0 0 1-.317-.765v-3.42q0-.443.32-.76A1.05 1.05 0 0 1 4.503 11h3.42q.445 0 .76.321.318.321.318.765v3.42q0 .443-.321.76a1.05 1.05 0 0 1-.764.318zM12.083 9q-.428 0-.755-.327A1.04 1.04 0 0 1 11 7.917V4.5q0-.442.328-.763.327-.32.755-.32H15.5q.443 0 .763.32t.32.763v3.417q0 .428-.32.756A1.03 1.03 0 0 1 15.5 9zm0 7.584q-.428 0-.755-.321a1.03 1.03 0 0 1-.328-.765v-3.42q0-.443.328-.76.327-.318.755-.318H15.5q.443 0 .763.321t.32.765v3.42q0 .443-.32.76a1.05 1.05 0 0 1-.763.318zM4.5 7.917h3.417V4.5H4.5zm7.583 0H15.5V4.5h-3.417zm0 7.583H15.5v-3.416h-3.417zm-7.583 0h3.417v-3.416H4.5z'
            />
        </g>
    </svg>
);
export default SvgGridView;
